import { Input } from "@fragments";
import { PersonRounded } from "@mui/icons-material";

import Section, { SectionRow } from "../Section";
import { useState } from "react";

export default function BankDocument({ REF_values }) {
    const [mode, setMode] = useState('INDIVIDUAL')

    const isIndividualMode = mode === 'INDIVIDUAL'

    return (
        <Section
            icon={<PersonRounded />}
            title="Dados pessoais / empresa"
        >

            <Input.Choices
                className="mt-2 mb-5"
                label="Tipo da conta"
                placeholder="Selecione o tipo de conta"
                options={[
                    { label: "Pessoa física", value: "INDIVIDUAL" },
                    { label: "Pessoa jurídica", value: "COMPANY" }
                ]}
                value={REF_values.current.owner.type}
                onInput={(value) => {
                    REF_values.current.owner.type = value
                    setMode(value)
                }}
            />

            <p>Dados da empresa</p>


            <SectionRow className="mt-3">
                {
                    isIndividualMode ? <>
                        <Input.CPF
                            value={REF_values.current.owner.document.number}
                            onInput={(value) => REF_values.current.owner.document.number = value}
                        />
                        <Input.Date
                            label="Data de nascimento"
                            value={REF_values.current.owner.birthdate}
                            onInput={(value) => REF_values.current.owner.birthdate = value}
                        />
                    </> : <>
                        <Input.Select
                            label="Enquadramento da empresa"
                            placeholder="Selecione a categoria"
                            options={[
                                { label: "MEI", value: "MEI" },
                                { label: "Limitada (LTDA)", value: "LIMITED" },
                                { label: "Individual", value: "INDIVIDUAL" },
                                { label: "Associação", value: "ASSOCIATION" }
                            ]}
                            value={REF_values.current.owner.company_type || 'LIMITED'}
                            onInput={(value) => {
                                REF_values.current.owner.company_type = value
                            }}
                        />
                        <Input.CNPJ
                            value={REF_values.current.owner.document.number}
                            onInput={(value) => REF_values.current.owner.document.number = value}
                        />
                    </>
                }
            </SectionRow>

            <SectionRow>
                <Input.Money
                    label={isIndividualMode ? "Renda mensal" : "Faturamento mensal"}
                    value={REF_values.current.owner.monthly_income}
                    onInput={(value) => REF_values.current.owner.monthly_income = value}
                />
                <Input.Phone
                    value={REF_values.current.owner.phone.number}
                    onInput={(value) => REF_values.current.owner.phone.number = value}
                />
            </SectionRow>
        </Section>

    );
}